/** @typedef {import('../lib/types.js').NoteContentBlock} NoteContentBlock */
import { designTokensDemoContent } from './demoContent/designTokens.seed'
import { ideasDemoContent } from './demoContent/ideas.seed'
import { launchChecklistDemoContent } from './demoContent/launchChecklist.seed'
import { meetingProductSyncActionsDemoContent } from './demoContent/meetingProductSyncActions.seed'
import { meetingProductSyncIntroDemoContent } from './demoContent/meetingProductSyncIntro.seed'
import { meetingStandupActionsDemoContent } from './demoContent/meetingStandupActions.seed'
import { meetingStandupDemoContent } from './demoContent/meetingStandup.seed'
import { mymanScratchDemoContent } from './demoContent/mymanScratch.seed'
import { researchDemoContent } from './demoContent/research.seed'
import { welcomeDemoContent } from './demoContent/welcome.seed'

/** @type {Record<string, NoteContentBlock[]>} */
export const NOTES_DEMO_CONTENT = {
  welcome: welcomeDemoContent,
  ideas: ideasDemoContent,
  designTokens: designTokensDemoContent,
  research: researchDemoContent,
  launchChecklist: launchChecklistDemoContent,
  mymanScratch: mymanScratchDemoContent,
  meetingStandup: [...meetingStandupDemoContent, ...meetingStandupActionsDemoContent],
  meetingProductSync: [...meetingProductSyncIntroDemoContent, ...meetingProductSyncActionsDemoContent],
}
